import * as React from "react";

import { cn } from "./utils";

/**
 * Поле ввода. По умолчанию просим браузер и менеджеры паролей не подставлять
 * сюда ничего: Safari на телефоне предлагает сохранённый пароль почти над
 * любым текстовым полем на том же домене, где однажды был вход, — и клавиатура
 * лезет с «Паролями» поверх поиска по аккаунтам или темы публикации.
 * Поля, которым автозаполнение нужно, передают свой autoComplete — он
 * перекрывает значение по умолчанию.
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      autoComplete="off"
      data-1p-ignore
      data-lpignore="true"
      data-form-type="other"
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base bg-input-background transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
